<template>
<div class="component">

    <div class="has-text-right"><span class="button is-info is-large" @click="openModal=true">{{$t('enaq_translation_market_new_offer_button')}}</span></div><br>

    <saleslist @selected="selectSale"></saleslist>
    <div v-if="selectedSale!=undefined">
        <showsale @close="selectedSale=null" :sale="selectedSale"></showsale>
    </div>

    <header class="modal-card-head" @click="openOwnSales = !openOwnSales">
        <p class="modal-card-title">{{$t('enaq_translation_market_your_offers')}}</p>
        <i class="fas fa-chevron-down"></i>
    </header>
    <div class="" v-if="openOwnSales">
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th class="has-text-centered" width="80%">{{$t('enaq_translation_market_your_offers_title')}}</th>
                    <th class="has-text-centered" width="10%">{{$t('enaq_translation_market_your_offers_add_image')}}</th>
                    <th class="has-text-centered" width="10%">{{$t('enaq_translation_market_your_offers_close_offer')}}</th>

                </tr>
            </thead>

            <tbody>
                <tr class="messageRow" v-for="sale in ownSales">

                    <td class="has-text-centered">{{sale.title}}</td>

                    <td v-if="sale.isopen" class="has-text-centered" @click="selectedSaleForImageUpload=sale.id"><i class="fas fa-images"></i></td>
                    <td v-else class="has-text-centered"><i class="fas fa-times"></i></td>

                    <td v-if="sale.isopen" class="has-text-centered" @click="closeSale(sale.id)"><i class="fas fa-trash"></i></td>
                    <td v-else class="has-text-centered">{{$t('enaq_translation_market_your_offers_closed')}}</td>

                </tr>
            </tbody>
        </table>
    </div>
    <div class="newSaleModal" v-if="openModal">
        <newsale @close="closeNewSale"></newsale> 
    </div>
    <div class="newSaleModal" v-if="selectedSaleForImageUpload>=0">
        <addimage :saleId="selectedSaleForImageUpload" @close="selectedSaleForImageUpload=-1"></addimage>
    </div>
</div>
</template>

<script>
import saleslist from '@/components/Sales/salesList.vue'
import newsale from '@/components/Sales/newSale.vue'
import showsale from '@/components/Sales/showSale.vue'
import addimage from '@/components/Sales/addImage.vue'

export default {
    name: 'Sales',
    props: [],
    components: {
        saleslist,
        newsale,
        showsale,
        addimage
    },
    mounted: function () {
        this.getOwnSales();
      //  alert(this.$tc('apple',1));
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            ownSales: [],
            openOwnSales: false,
            openModal: false,
            addImageModal: true,
            selectedSaleForImageUpload: -1,
            selectedSale: null
        }
    },
    methods: {
        getOwnSales() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                year: this.currentYear + "",
                month: this.currentMonth + ""
            }
            this.$axios.get(this.$backendURL + "/sales/own", {
                headers: headerData
            }).then(function (result) {
                this.ownSales = result.data.sales
            }.bind(this))
        },
        deleteSale(saleId) {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {}
            this.$axios.post(this.$backendURL + "/sales/" + saleId + "/delete", postData, {
                headers: headerData
            }).then(function (result) {
                this.getOwnSales();
            }.bind(this))
        },
        closeSale(saleId) {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {}
            this.$axios.post(this.$backendURL + "/sales/" + saleId + "/close", postData, {
                headers: headerData
            }).then(function (result) {
                this.getOwnSales();
            }.bind(this))
        },
        selectSale(sale) {
            this.selectedSale = sale;
        },
        closeNewSale() {
            this.openModal = false;
            this.getOwnSales();
        }
    },
    computed: {},
}
</script>

<style scoped>
.modal-card-head{
    cursor:pointer;
}
</style>
